<script lang="ts">
  import Label from "@components/ui/Label.svelte"
  import RadioButtons from "@components/ui/RadioButtons.svelte"
  import RadioButton from "@components/ui/RadioButton.svelte"
  import ErrorMessage from "@components/ui/ErrorMessage.svelte"

  import { Cancellation, canBeRefundedUsingStripe } from "@models/cancellations/Cancellation"
  import { totalNonRefundable } from "@models/cancellations/NonRefundableAdjustment"
  import { formatCentsAsUsd } from "@util/money"
  import { ValidationErrors } from "@util/validations"

  export let cancellation: Cancellation
  export let submitted: boolean = false
  export let errors: ValidationErrors<Cancellation> = {}
  export let insuranceOnly: boolean = false
</script>

<div class="sm:col-span-2">
  <div class="grid sm:grid-cols-3 -mt-1">
    <div class="sm:col-span-3">
      <Label name="method" required>Refund Method</Label>
      <RadioButtons>
        <RadioButton
          name="method"
          bind:group={cancellation.refundMethod}
          value="stripe"
          disabled={!canBeRefundedUsingStripe(cancellation, insuranceOnly)}
        >
          Electronic Refund
          {#if totalNonRefundable(cancellation.nonRefundableAdjustments, insuranceOnly) > 0}
            ({formatCentsAsUsd(cancellation.maxStripeRefundable)} max)
          {:else}
            ({formatCentsAsUsd(cancellation.maxStripeRefundable + cancellation.totalConvenienceFeesFromPayments + cancellation.totalAffirmFeesFromPayments)} max)
          {/if}
        </RadioButton>
        <RadioButton name="method" bind:group={cancellation.refundMethod} value="manual">Manual Refund</RadioButton>
      </RadioButtons>
    </div>

    {#if cancellation.refundMethod === "manual"}
      <div class="sm:col-span-3">
        <Label name="reference" required>Manual Refund Reference</Label>
        <input
          id="reference"
          name="reference"
          type="text"
          data-role="reference"
          bind:value={cancellation.manualReference}
          placeholder="Check #, Reference # etc. (shown to passengers)"
          aria-required
        />
        <ErrorMessage when={submitted} error={errors.manualReference} />
      </div>
    {/if}
  </div>
</div>
